import {connect} from "react-redux"
import {State} from "../../ducks"

export const mapStateToProps = ({data, textAlignment, text, template}: State) => {
    return {data, textAlignment, text, template}
}

export default connect(mapStateToProps)
